import { FormControl, Switch } from '@cdl/heartbeat-react';
import { Controller, Control } from 'react-hook-form';

type Props = {
  control: Control<any>;
  type: string;
};

const switchOptions = [
  { label: 'P', name: 'P' },
  { label: 'QRS', name: 'QRS' },
  { label: 'T', name: 'T' },
  { label: 'INV', name: 'INV' },
];

export const SwitchForm: React.FC<Props> = ({ control, type }) => {
  return (
    <FormControl display='flex' gap='xl'>
      {switchOptions.map(({ label, name }) => (
        <Controller
          key={name}
          control={control}
          name={`settings.platane_annotation_settings.${type}.${name}`}
          defaultValue={true}
          render={({ field: { value, onChange } }) => (
            <Switch isChecked={value} size='md' onChange={onChange}>
              {label}
            </Switch>
          )}
        />
      ))}
    </FormControl>
  );
};
